/**
 * API configuration for KobSign Word Add-in.
 *
 * In development, Vite proxy forwards /api → localhost:8000
 * In production, we point directly at api.kobsign.com
 */

const hostname = window.location.hostname
const isProduction = hostname === 'word.kobsign.com' ||
  hostname === 'kobsign-word-addin.pages.dev' ||
  hostname.endsWith('.kobsign-word-addin.pages.dev') ||
  hostname.endsWith('.kobsign.pages.dev')

const envApiUrl = import.meta.env.VITE_API_URL || (isProduction ? 'https://api.kobsign.com/api/v1' : '/api/v1')

export const API_V1 = envApiUrl.includes('/api/v1')
  ? envApiUrl
  : `${envApiUrl}/api/v1`

export const API_BASE = envApiUrl.includes('/api/v1')
  ? envApiUrl.replace('/api/v1', '')
  : envApiUrl

/** Main web app URL — for "View in KobSign" links */
export const MAIN_APP_URL = isProduction
  ? 'https://kobsign.com'
  : 'http://localhost:5173'

/**
 * Login URL for Dialog API.
 * Points to auth-callback.html (same origin as task pane) so Office.js
 * _host_Info params are preserved. The callback page then redirects to
 * OAuth login if no user data is present.
 */
export const LOGIN_URL = `${window.location.origin}/auth-callback.html`

/** Backend callback that redirects back to auth-callback.html with user data */
export const OFFICE_CALLBACK_URL = `${API_BASE}/api/v1/office/callback`
